/**
 * simVoice — 약달력 시뮬 음성 안내(스피커). 다국어.
 *
 * 우선순위: (1) 사전 생성 neural mp3 `/tts/{locale}/{key}.mp3` → (2) 실패 시 브라우저 내장 TTS(해당 로캘).
 * 둘 다 온프레미스(클라우드 미사용). 음소거 토글은 localStorage('sim.voice').
 */
const BCP47: Record<string, string> = { ko: 'ko-KR', en: 'en-US', vi: 'vi-VN', ja: 'ja-JP', zh: 'zh-CN' }
export const VOICE_SLOT_KEY = ['morning', 'lunch', 'dinner', 'bedtime'] as const

let _muted = (() => {
  try { return localStorage.getItem('sim.voice') === 'off' } catch { return false }
})()
export function isVoiceMuted(): boolean { return _muted }
export function setVoiceMuted(m: boolean): void {
  _muted = m
  try { localStorage.setItem('sim.voice', m ? 'off' : 'on') } catch { /* ignore */ }
  if (m) { try { window.speechSynthesis.cancel() } catch { /* ignore */ } }
}

let _last: HTMLAudioElement | null = null

/** 음성 재생 — mp3 우선, 실패 시 speechSynthesis 폴백. text 는 폴백용(이미 로캘 반영된 문장). */
export function speak(mp3Key: string, text: string, locale: string): void {
  if (_muted || !text) return
  try { _last?.pause() } catch { /* ignore */ }
  try { window.speechSynthesis?.cancel() } catch { /* ignore */ }
  const a = new Audio(`/tts/${locale}/${mp3Key}.mp3`)
  _last = a
  a.play().catch(() => {
    try {
      const u = new SpeechSynthesisUtterance(text)
      u.lang = BCP47[locale] ?? 'ko-KR'
      window.speechSynthesis.speak(u)
    } catch { /* TTS 미지원 — 무음 */ }
  })
}
